<template>
  <div>
    <div class="authority" v-if="status == true">
      <div class="content">
        <p>您没有权限查看页面</p>
        <p>如需开通请联系系统管理员</p>
      </div>
    </div>
    <div v-else class="rbox">
      <div>
        <div class="box">
          <p class="return" @click="back">返回首页</p>
          <span class="line">|</span>
          <p class="contract">系统设置</p>
          <span class="lines">></span>
          <p class="contract">组织管理</p>
        </div>
        <div class="p_btn">
          <div>
            <div class="mainTitle" @click="sort">组织管理</div>
          </div>

          <button class="btn subbtn" @click="add">新增组织</button>
        </div>
        <div>
          <SsgMessagebox
            :titles="tempShow ? '新增组织' : '编辑组织'"
            v-if="maskshow && masktype == 'modifys'"
            height="300px"
            width="500px"
            @sub="addOrg"
            @shut="closewin"
          >
            <el-form
              :model="addForm"
              :rules="rules"
              label-width="100px"
              ref="addForm"
              class="demo-ruleForm"
            >
              <el-form-item
                label="组织名称"
                prop="orgName"
                haveto="true"
                style="margin-bottom: 20px"
              >
                <el-input
                  v-model="addForm.orgName"
                  maxlength="50"
                  placeholder="请输入组织名称"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="上级组织"
                prop="positionId"
                haveto="true"
                style="margin-bottom: 20px"
              >
                <el-treeselect
                  v-model="addForm.positionId"
                  placeholder="请选择"
                  :data="positionList"
                  :props="props"
                  :search="false"
                ></el-treeselect>

                <!-- <el-select v-model="addForm.positionId" placeholder="请选择">
								<el-option :label="v.name" :value="v.id" v-for="(v,k) in positionList" :key="k"></el-option>
                </el-select>-->
              </el-form-item>
              <el-form-item
                v-if="tempShow == false"
                label="组织负责人"
                prop="userId"
              >
                <button
                  type="button"
                  class="btn"
                  @click="returactor"
                  tag="button"
                >
                  选择组织负责人
                </button>
                <span
                  v-if="addForm.userNames"
                  style="
                    background-color: #888888;
                    color: white;
                    font-size: 12px;
                    margin: 0px 3px;
                    padding: 4px;
                    border-radius: 3px;
                  "
                >
                  {{ addForm.userNames }}
                  <i
                    style="color: white; cursor: pointer"
                    class="el-icon-close"
                    @click="deletpepoe"
                  ></i>
                </span>
              </el-form-item>
            </el-form>
          </SsgMessagebox>

          <SsgMessagebox
            style="z-index: 10000"
            titles="选择组织负责人"
            v-if="maskshow && masktype == 'aa'"
            height="655px"
            width="628px;"
            @sub="subSort"
            @shut="shutadd"
          >
            <el-table
              :data="lists"
              style="width: 100%"
              :header-cell-style="{ background: '#f8fafb', color: '#303140' }"
            >
              <el-table-column label="姓名" prop="name" min-width="15%">
                <template slot-scope="scope">
                  <el-radio
                    v-model="checked"
                    style="margin-left: -10px"
                    @change.native="getTemplateRow(scope.$index, scope.row)"
                    :label="scope.row.userId"
                    >{{ scope.row.name }}</el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="手机号"
                prop="mobile"
                min-width="20%"
              ></el-table-column>
            </el-table>
          </SsgMessagebox>
          <addorginstaff
            v-if="maskshow && masktype == 'modify'"
            :type="1"
            @sub="submodify"
            :default="orginlist"
            :parentListDefault="selectIds"
          ></addorginstaff>
          <div class="table">
            <!-- <tree-table
              :data="data"
              :columns="columns"
              @deleOrgList="deleOrgList"
              @onmodifyCharge="onmodify"
              @handleCommand="handleCommand"
              :expandAll="true"
              v-if="tablevisible"
            /> -->
            <div style="border: 1px solid #eee">
              <div class="tree">
                <div class="title">组织管理</div>
                <div style="padding: 10px 20px">
                  <div class="c_name c_checked" style="cursor: pointer">
                    <el-input
                      placeholder="请输入姓名或手机号"
                      prefix-icon="el-icon-search"
                      v-model="searchvalue"
                      @keyup.enter.native="searchEnterFun"
                      @change="onsubmit"
                      clearable
                    ></el-input>
                  </div>
                  <div class="c_tree">
                    <el-tree
                      @node-click="filterNode"
                      :data="data"
                      :props="defaultProps"
                      node-key="id"
                      ref="trees"
                    >
                      <span
                        class="custom-tree-node"
                        slot-scope="{ node, data }"
                      >
                        <span>{{ node.label }}</span>
                        <span
                          class="operation"
                          v-if="
                            selectedNodeId === data.id && data.parentId !== 0
                          "
                        >
                          <i
                            class="el-icon-edit"
                            @click.stop="handleCommand({ flag: 2, row: data })"
                          ></i>
                          <i
                            class="el-icon-delete"
                            @click.stop="handleCommand({ flag: 4, row: data })"
                          ></i>
                          <i
                            class="el-icon-circle-plus-outline"
                            @click.stop="handleCommand({ flag: 1, row: data })"
                          ></i>
                        </span>
                      </span>
                    </el-tree>
                  </div>
                </div>
              </div>
            </div>

            <el-table
              :data="datalist"
              style="width: 100%"
              :fit="true"
              :header-cell-style="{ background: '#f8fafb', color: '#303140' }"
            >
              <!-- <el-table-column prop="name" label="组织名称" min-width="120" align="left">
                <template slot-scope="scope">
                  <router-link
                    v-if="scope.row.parentId != 0"
                    :to="{path: '/organizationlist/organization/details', query: {id: scope.row.id}}"
                    tag="a"
                    class="link"
                    replace
                  >{{scope.row.name}}</router-link>
                  <span v-else>{{scope.row.name}}</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="name" label="姓名" align="left" min-width="100">
                <template slot-scope="scope">{{ scope.row.name }}
                  <el-tooltip v-if="scope.row.org_manage_flag == 0" placement="right" effect="light" >
              <div class="title" slot="content">{{scope.row.org_manage_name}}负责人</div>
             		<i class="el-icon-question" style="color: #b8b8c4;font-size: 14px;"></i>

            </el-tooltip>
                  <span
                v-if="
                  scope.row.admin_type == 0
                "
                class="span_bgc1"
                >管理员</span
              >
                </template>
              </el-table-column>
              <el-table-column prop="mobile" label="手机号" align="left">
                <!-- <template slot-scope="scope">
                  <span class="modify">
                    {{ scope.row.chargeName | null }}
                    <i @click="onmodify(scope.row)"></i>
                  </span>
                </template> -->
              </el-table-column>
              <el-table-column prop="org_name" label="组织名称" :show-overflow-tooltip="true" min-width="140" align="left" >
              </el-table-column>
              <el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true" min-width="130" align="left">
              </el-table-column>
              <el-table-column prop="group_name" label="权限组" :show-overflow-tooltip="true" min-width="120" align="left">
              </el-table-column>
              <el-table-column
                prop="last_login_time"
                label="最近登陆时间"
                align="left"
                min-width="130"
              >
              </el-table-column>
              <el-table-column prop="status" label="状态" align="left">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 1"  class="span_bgc4">启用中</span>
                  <span v-if="scope.row.status == 0" class="span_bgc">停用中</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="right">
                <template slot-scope="scope">
                  <div   v-if="
                  btnPermissionsStr.includes('func:acount:open') ||
                  btnPermissionsStr.includes('func:acount:edit') ||
                  btnPermissionsStr.includes('func:account:editpermission')
                ">
                    <el-dropdown
                    v-if="scope.row.admin_type !== 0"
                      @command="handleCommand"
                      placement="bottom"
                      size="small"
                    >
                      <span class="el-dropdown-link menu">
                        <span></span>
                        <i>操作</i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <div>
                          <el-dropdown-item
                            :command="{ flag: 5, row: scope.row }"
                            >设置组织负责人</el-dropdown-item
                          >
                        </div>
                        <div>
                          <el-dropdown-item
                            v-if="scope.row.status == 1"
                            :command="{ flag: 6, row: scope.row }"
                            >停用</el-dropdown-item
                          >
                          <el-dropdown-item
                            v-if="scope.row.status == 0"
                            :command="{ flag: 6, row: scope.row }"
                            >启用</el-dropdown-item
                          >
                        </div>

                        <div>
                          <el-dropdown-item
                            :command="{ flag: 7, row: scope.row }"
                            >编辑信息</el-dropdown-item
                          >
                        </div>
                        <div>
                          <el-dropdown-item
                            :command="{ flag: 8, row: scope.row }"
                            >编辑权限</el-dropdown-item
                          >
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
              
            </el-table>
           
           
          </div>
        
              <page
            :page="pageNum"
            :pagesize.sync="pageSize"
            :total="total"
            @currentChange="cur"
            @enter="cur"
            v-show="total > 0"
            :pageNum="pageNum"
          ></page>
            
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import treeTable from "@/components/common/TreeTable";
import groupBtn from "@/components/common/groupBtnPermission";

export default {
  data() {
    return {
      datalist: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      selectedNodeId: null,
      searchvalue: "",
      status: false,
      props: {
        label: "name",
        value: "id",
        children: "childs",
      },
      tempShows: true,
      delet: false,
      subMessage: "",
      templateSelection: {},
      checked: "",
      currentSelectItem: {}, // 当前选中的值
      lists: [],
      rules: {
        orgName: [
          {
            required: true,
            message: "请输入组织名称",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/,
            message: "不能输入空格",
          },
        ],
        positionId: [
          {
            required: true,
            message: "请选择上级组织",
            trigger: "change",
          },
        ],
      },
      addForm: {
        positionId: "",
        orgName: "",
        userId: "",
        userName: "",
        id: "",
        userNames: "",
      },
      addForms: {
        positionId: "",
        orgName: "",
        userId: "",
        userName: "",
        id: "",
        userNames: "",
      },
      positionList: [],
      tempShow: true,
      orgid: "",
      orginlist: [],
      selectIds: [],
      orgLists: [],
      columns: [
        {
          text: "组织名称",
          value: "name",
          width: 800,
          link: true,
        },
        {
          text: "在职人数",
          value: "num",
          // width: 200
        },
        {
          text: "负责人",
          value: "chargeName",
          // width: 200
        },
        {
          text: "操作",
          value: "edit",
          // width: 800,
          align: "right",
        },
      ],
      defaultProps: {
        children: "childs",
        label: "name",
      },
      // morebtns: [{
      // 		name: '批量删除',
      // 		url: "relationship/addToBeEmployed"
      // 	},
      // 	{
      // 		name: '导出组织',
      // 		action: 'exportOrg',
      // 		btnPermissions: 'func:org:exp'
      // 	}
      // ],
      data: [],
      list: [],
      tablevisible: true,
      chargeNameList: [],
      addorgVisible: false,
      searchval: "",
      maskshow: false,
      masktype: "",
      mergeshow: false,
      modify: {
        id: "",
        userId: "",
      },
      chargerules: {
        userId: [
          {
            required: true,
            message: "请输入负责人姓名",
            trigger: "change",
          },
        ],
      },
      merge: {},
      pastDays: 0,
      chooseId: "",
      orgModel: {},
      stringify: "",
      btnPermissionsStr:{}
    };
  },
  mounted() {
    this.btnPermissionsStr = sessionStorage.getItem("btnPermissions");
  },
  created() {
    this.loadTableTree();
    this.filterOrg();
  },
  watch: {
    searchval(val) {
      if (val) {
        this.tablevisible = false;
        this.filterOrg(val);
      } else {
        this.tablevisible = true;
      }
    },
  },
  methods: {
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
    
      if (keyCode == 13) {
        this.onsubmit();
      }
    },
    onsubmit() {
      this.pageNum = 1;
      this.loadList();
    },
    //分页方法
    cur(val) {

      this.pageNum = val;
      this.loadList();
    },
    //切换部门
    filterNode(data) {
      this.selectedNodeId = data.id;
      this.pageNum = 1;
      this.loadList();
      //         this.$nextTick(() => {
      //   this.$refs.trees.setCurrentKey(data.id);
      // });
      // this.form.pageNum = 1
      // this.form.orgId = data.id
      // this.loadData()
    },
    // 根据组织查询账号
    loadList(id) {
      if (id) {
        this.selectedNodeId = id;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.searchvalue,
        mobile: "",
        orgId: this.selectedNodeId,
      };
      return this.$axios
        .get("userInfo/queryList", {
          params,
        })
        .then((res) => {
          if (res.data.status == 2) {
            this.status = true;
          } else {
            this.datalist = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    back() {
      this.$router.push({ path: "/main" });
    },
    deletpepoe() {
      this.addForm.userNames = "";
      this.addForm.userId = "";
      this.delet = true;
    },
    subSort() {
      if (this.templateSelection.orgId && this.templateSelection.userId) {
        return this.$axios
          .post(
            "org/editUserForOrg?id=" +
              this.templateSelection.orgId +
              "&userId=" +
              this.templateSelection.userId
          )
          .then((res) => {
            if (res.data.status == 1) {
              this.maskshow = false;
              this.masktype = "aa";
              if (this.tempShows == true) {
                this.loadTableTree();
              } else {
                this.maskshow = true;
                this.masktype = "modifys";
                this.addForm.userId = this.templateSelection.userId;
                this.addForm.userNames = this.templateSelection.name;
              }
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            //处理错误
            console.error(err);
          });
      } else {
        this.maskshow = true;
        this.masktype = "modifys";
      }
    },
    shutadd() {
      this.maskshow = false;
      this.masktype = "aa";
      if (this.tempShows == true) {
      } else if (this.tempShows == false) {
        this.maskshow = true;
        this.masktype = "modifys";
      }
    },

    returactor() {
      this.maskshow = true;
      this.masktype = "aa";
      this.tempShows = false;
      this.lists = [];
      this.$axios.get("/org/getUserList?id=" + this.addForm.id).then((res) => {
        if (res.data.status == 1) {
          this.lists = res.data.data;
          if (this.addForm.userNames) {
            for (var i = 0; i < this.lists.length; i++) {
              if (this.addForm.userId === this.lists[i].userId) {
                this.checked = this.lists[i].userId;
              }
            }
          } else {
            this.checked = "";
          }
        }
      });
    },
    getTemplateRow(index, row) {
      this.templateSelection = row;
  
    },

    handleSelectionChange(row) {
      // 如果使用单选框,这里可以把当前选中的这一项先保存起来
      this.currentSelectItem = row;
    },
    sort() {
      this.maskshow = true;
      this.masktype = "addSort";
    },
    deleOrgList(name, id, orgId) {
      this.orginlist = [...id];
      this.selectIds = [...name];
      this.orgid = orgId;


      this.addOrgPeps();
    },
    filterOrg() {
      this.$axios.get("/org/getOrgList").then((res) => {
        if (res.data.status == 1) {
          this.positionList = res.data.data;
        
        }
      });
    },
    handleCommands(command) {
      if (command == "a") {
        this.exportOrg();
      } else if (command == "b") {
        this.$router.push("organization/delete");
      }
    },
    loadTableTree() {
      this.$axios.get("/org/getAllOrgTree").then((res) => {
        if (res.data.status == 1) {
          this.data = res.data.data;
         
          this.$nextTick(() => {
            // 数据更新后，重新设置默认展开或高亮
            this.$refs.trees.setCurrentKey(this.data[0]?.id || null);
          });
          if (this.data[0]?.id) {
            this.loadList(this.data[0].id);
          }
        } else if (res.data.status == 2) {
          this.status = true;
        }
      });
    },
    handleCommand(command) {
   
      if (command.flag == 1) {
        this.filterOrg();

        this.tiels = "新增组织";
        this.addorgVisible = true;
        this.tempShow = true;

        this.maskshow = true;
        this.masktype = "modifys";
        // this.addForm.positionId= '';
        // this.addForm.orgName = '';
        this.addForm = {};
        this.addForm.positionId = command.row.id;
     
      }
      if (command.flag == 2) {
        this.tiels = "编辑组织";
        this.tempShow = false;
        this.maskshow = true;
        this.masktype = "modifys";
        var obj = {};
        this.addForm.orgName = command.row.name;
        this.addForm.positionId = command.row.parentId;
        this.addForm.userNames = command.row.userName;
        this.addForm.userId = command.row.userId;
        this.addForm.id = command.row.id;
        this.$axios
          .get("/org/getOrgList?type=" + 1 + "&orgId=" + command.row.id)
          .then((res) => {
            if (res.data.status == 1) {
              this.positionList = res.data.data;

            }
          });
      }
      if (command.flag == 3) {
        this.mergeshow = true;
        let params = {
          id: command.row.id,
          pNumber: command.row.pNumber,
          orgName: command.row.label,
        };
        this.merge = params;
      }
      if (command.flag == 4) {
        this.$confirm(
          "您确定要删除名称为【" + command.row.name + "】的组织吗?",
          "删除组织",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.$axios
            .post("/org/deleteOrg?id=" + command.row.id)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.loadTableTree();
              } else {
                this.$message.error(res.data.message);
              }
            });
        });
      }
      if (command.flag == 5) {
        this.$axios
          .post(
            "org/editUserForOrg?id=" +
            command.row.org_id +
              "&userId=" +
              command.row.user_id
          )
          .then((res) => {
            if (res.data.status == 1) {
              this.$message.success(res.data.message);
              this.loadList();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            //处理错误
            console.error(err);
          });
      }
      if (command.flag == 6) {
        const newStatus = command.row.status == 1 ? false : true;
        this.$axios
          .post(
            `userInfo/operateServerUser?userId=${command.row.user_id}&status=${newStatus}`
          )
          .then((res) => {
            if (res && res.data) {
              // 建议增加响应校验
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.loadList();
              } else {
                this.$message.error(res.data.message);
              }
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
      if (command.flag == 7) {
        this.$router.push({
          path: "account/addAccount",
          query: {
            id: command.row.user_id,
            edit: "true",
            flag: 7,
          },
        });
      }
      if (command.flag == 8) {
        this.$router.push({
          path: "account/jurisdiction",
          query: {
            id: command.row.user_id,
            edit: "true",
            flag: 8,
          },
        });
      }
    },

    addorganization() {
      this.tiels = "新增组织";
      this.addorgVisible = true;
      this.orgModel = {};
      this.chooseId = this.data[0].id;
    },

    //列表添加负责人
    onmodify(val) {
      this.tempShows = true;
      this.$axios.get("/org/getUserList?id=" + val.id).then((res) => {
        if (res.data.status == 1) {
          this.lists = res.data.data;
          if (!this.addForm.userName) {
            this.checked = "";
          }
        }
      });
      this.orginlist = [
        ...(val.userId != null ? val.userId.toString().split(",") : []),
      ];
      this.selectIds = [
        ...(val.chargeName != null ? val.chargeName.toString().split(",") : []),
      ];
      // this.chargeNameList = [{
      //   chargeName: val.chargeName,
      //   userid: val.userId
      // }];
      this.maskshow = true;
      this.masktype = "aa";
      this.modify.userId = val.userId;
      this.modify.id = val.id;
      this.orgid = val.id;
      // this.addOrgPeps()
    },
    submodify(ids, name) {
      this.orginlist = [...ids];
      this.selectIds = [...name];
      this.addOrgPeps();
    },
    add() {
      this.maskshow = true;
      this.masktype = "modifys";
      this.tempShow = true;
      this.addForm.orgName = "";
      this.addForm.positionId = "";
      this.addForm.userName = "";
      this.addForm.userId = "";
    },
    closewin() {
      this.maskshow = false;
      this.masktype = "modifys";
    },

    // 添加组织
    addOrg() {
      this.$refs.addForm.validate((status) => {
        if (status == true) {
          if (this.tempShow == true) {
            return this.$axios
              .post(
                "org/addOrg?name=" +
                  this.addForm.orgName +
                  "&parentId=" +
                  this.addForm.positionId
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.maskshow = false;
                  this.loadTableTree();
                  this.filterOrg();
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                console.error(err);
              });
          } else {
            return this.$axios
              .post(
                "org/updateOrg?name=" +
                  this.addForm.orgName +
                  "&parentId=" +
                  this.addForm.positionId +
                  "&userId=" +
                  this.addForm.userId +
                  "&id=" +
                  this.addForm.id
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.maskshow = false;
                  if (this.delet) {
                    this.delet = false;
                    this.$axios
                      .post(
                        "org/editUserForOrg?id=" +
                          this.addForm.id +
                          "&userId=" +
                          ""
                      )
                      .then((res) => {
                        if (res.data.status == 1) {
                          this.addForm.userName = "";
                          this.addForm.userId = "";
                          this.loadTableTree();
                          this.filterOrg();
                        } else {
                          this.$message.error(res.data.message);
                        }
                      })
                      .catch((err) => {
                        //处理错误
                        console.error(err);
                      });
                  }
                this.pageNum = 1
                  this.loadList();
                  // this.loadTableTree();
                } else {
                  this.maskshow = false;
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                this.maskshow = false;
                console.error(err);
              });
          }
        }
      });
    },

    addOrgPeps() {
      var param =
        "orgId=" +
        this.orgid +
        "&userId=" +
        this.orginlist.toString() +
        "&userName=" +
        this.selectIds.toString();
      return this.$axios
        .post(
          "org/editUserForOrg?id=" +
            this.orgid +
            "&userId=" +
            this.orginlist.toString()
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.loadTableTree();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    remoteMethod(query) {
      this.$axios
        .get("/employee/findOrgChargeNameInEmployee?name=" + query)
        .then((res) => {
          if (res.data.status == 1) {
            this.chargeNameList = res.data.data;
          }
        });
    },
    callback(data) {
      this.tablevisible = true;
      this.loadTableTree();
    },
    exportOrg() {
      const loading = this.$loading({
        text: "正在下载，请稍后",
      });
      this.$axios
        .get("/batchorg/export", {
          responseType: "blob",
        })
        .then((res) => {
          let blob = res.data;
          let reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (e) => {
            let a = document.createElement("a");
            let headers = res.headers;
            let fileName = headers["content-disposition"];
            a.download = this.getCharFromUtf8(fileName);
            a.href = e.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            loading.close();
          };
        });
    },
  },
  components: {
    treeTable,
    groupBtn,
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
.tab_nav {
  height: 72px;
}

.form {
  width: 100%;
  margin: 30px 0;
}

.el-select {
  width: 100%;
}

.modify {
  display: flex;
  align-items: center;
}

.modify i {
  width: 18px;
  height: 18px;
  display: block;
  background-image: url(../../../assets/img/organization03.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 18px;
  margin-left: 5px;
  cursor: pointer;
}

/*.modify i:hover {*/
/*background-image: url(../../../assets/img/rename_b.png);*/
/*}*/

.link {
  color: #6669e3;
  cursor: pointer;
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0 14px 0;
}
.authority {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: 100px auto;

  .content {
    text-align: center;
    margin: 50px auto;
    font-size: 24px;
    font-weight: bold;
    color: #303140;
  }
}
.c_tree /deep/ .el-tree-node.is-current > .el-tree-node__content {
  color: #6669e3;
}
.c_tree /deep/ .el-tree .is-current:after {
  width: 0;
}

.table {
  display: flex;
  .title {
    height: 48px;
    line-height: 48px;
    background: rgb(248, 250, 251);
    /* color: rgb(48, 49, 64); */
    font-size: 12px;
    color: #303140;
    font-weight: bold;
  }
}
.span_bgc1 {
  padding: 3px 5px;
  background-color: #ff6752;
  color: #fff;
  border-radius: 4px;
}
.span_bgc {
  padding: 2px 9px;
  background: rgba(254, 240, 240, 1);
  border-radius: 4px;
  border: 1px solid rgba(252, 210, 210, 1);
  font-size: 12px;
  font-weight: 400;
  color: rgba(245, 116, 116, 1);
}

.span_bgc4 {
  padding: 2px 9px;
  background: rgba(234, 255, 248, 1);
  font-size: 12px;
  font-weight: 400;
  border: 1px solid #b7e1d3;

  color: rgba(59, 199, 152, 1);
  border-radius: 4px;
}
.operation {
  margin-left: 10px;
  i {
    margin-left: 5px;
  }
}

</style>
